<div
  class="scroll-container {{ classes() }}"
  [id]="uniqueId()"
  #scrollContainer
>
  <ng-content></ng-content>

</div>
